const icon = require('./icons/sitting-on-chair-100.png')

export const SedentaryIcon = () => {
  return <img src={icon} alt="sedentary icon" className="w-full h-full"/>
}
